if (document.getElementsByClassName('template-product').length==0) {
const insertBeforeElementBackup = Element.prototype.insertBefore
Element.prototype.insertBefore= function(...args) {   
  if(!args[0].outerHTML || (args[0].outerHTML && args[0].outerHTML.indexOf("spr.js") ==-1))   
    return insertBeforeElementBackup.apply(this,args)
  }
}

//prevent load font awesome  from 3rd party
const appendElementBackup = Element.prototype.appendChild;
Element.prototype.appendChild= function(...args) { 
  if (args[0].nodeName && args[0].nodeName=='SCRIPT' && args[0].src.indexOf('jquery.min.js')!=-1) {
    if (window.SPR!=undefined) {
      $.ajaxSetup({ cache: !0 }),
      SPR.loadjQueryExtentions($),
      $(document).ready(function () {
        SPR.$=jQuery;
		return SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges();
      })
    }
    return ;
  }
 if(!args[0].outerHTML || (args[0].outerHTML && args[0].outerHTML.indexOf("maxcdn.bootstrapcdn.com/font-awesome/4.6.3/css/font-awesome.min.css") ==-1))      
   return appendElementBackup.apply(this,args)
}

if ($('link[href="https://maxcdn.bootstrapcdn.com/font-awesome/4.4.0/css/font-awesome.min.css"]').length>0)
$('link[href="https://maxcdn.bootstrapcdn.com/font-awesome/4.4.0/css/font-awesome.min.css"]').remove()

var W_width = $(window).width(), W_height = $(window).height();
$(window).on('resize', function () {
  if($(window).width() != W_width || $(window).height() != W_height){
    W_width = $(window).width();
    W_height = $(window).height();
    _initResize();
  }
});
$(window).on('load', function () {
  _initResize();
});

// Filters
function _initResize() {
  initSwatches();
  $('.filter-refine').off('click');
  $('.filter-overlay, .filter__close, .filter__apply').off('click');
  $('.filter-sort__title').off('click');
  $(document).off('click.resize');
  $('.filter-sort-overlay').removeClass('filter-sort-overlay--active');
  $('.filters__container').removeClass('filters__container--sticky');
  $('html').removeClass('no-scroll');
  $('.filter-sort__list').css('display','');
  $('.filter-sort').off('click');
  // Filters Mobile/Tablet
if ($(window).width() < 1365) {
  // Filters - Open
  $('.filter-refine').on('click', function () {
    $('.filter').toggleClass('filter--active');
    $('.filters__container').removeClass('filters__container--sticky');
    $('.filter-overlay').addClass('filter-overlay--active');
    $('html').addClass('no-scroll');
    return false;
  });

  // Filter - Close
  $('.filter-overlay, .filter__close, .filter__apply').on('click', function () {
    $('.filter').removeClass('filter--active');
    $('.filter-overlay').removeClass('filter-overlay--active');
    $('html').removeClass('no-scroll');
    return false;
  });
}

// Sort Tablet/Desktop
if ($(window).width() > 599) {
  $('.filter-sort__title').on('click',function(e) {
    e.preventDefault();
  
    var $this = $(this);
  
    if ($this.next().hasClass('filter-sort__list--active')) {
      $this.next().removeClass('filter-sort__list--active');
      $this.next().slideUp(150);
    } else {
      $this.parent().parent().find('.filter-sort .filter-sort__list').removeClass('filter-sort__list--active');
      $this.parent().parent().find('.filter-sort .filter-sort__list').slideUp(150);
      $this.next().toggleClass('filter-sort__list--active');
      $this.next().slideToggle(150);
    }

    if ($this.hasClass('filter-sort__title--active')) {
      $this.removeClass('filter-sort__title--active');
    } else {
      $this.parent().find('.filter-sort .filter__title').removeClass('filter-sort__title--active');
      $this.toggleClass('filter-sort__title--active');
    }

  });

  $(document).on('click.resize',function (e) {
    if (!$(e.target).is(".filter-sort *")) {
      $('.filter-sort__list').removeClass('filter-sort__list--active');
      $('.filter-sort__title').removeClass('filter-sort__title--active');
      $('.filter-sort__list').slideUp(150);
    }
  }); 
}

// Sort Mobile
if ($(window).width() < 600) {
  $('.filter-sort').on('click', function () {    
    $(this).children('.filter-sort__list').toggleClass('filter-sort__list--active');
    $('.filter-sort-overlay').toggleClass('filter-sort-overlay--active');
    $('.filters__container').removeClass('filters__container--sticky');
    $('html').toggleClass('no-scroll');
    return false;
  });
  $(document).on('click.resize',function (e) {
    if (!$(e.target).is(".filter-sort *") && !$(e.target).is(".filter__group *")) {
      $('.filter-sort__list').removeClass('filter-sort__list--active');
      $('.filter-sort-overlay').removeClass('filter-sort-overlay--active');
      $('html').removeClass('no-scroll');
      
    }
  }); 
}
previousScroll = 0;
headerOrgOffset = 0;
if ($(window).width() > 1365) {
  if ($('.header').length>0)  headerOrgOffset = $('.header').offset().top + 28;
} else {
  if ($('.header').length>0)  headerOrgOffset = $('.header').offset().top;
}
  
};
// Filters All
$(document).ready(function() {

  loadswatches();
 _initFilter();

  $(document).click(function (e) {
    if (!$(e.target).is(".filter__group *")) {
      $('.filter__list').removeClass('filter__list--active');
      $('.filter__title').removeClass('filter__title--active');
      $('.filter__list').slideUp(150);
    }
  });
});


function _initFilter() {
   // Filter - Accordion
  $('.filter__title').off('click').on('click',function(e) {
    e.preventDefault();
  
    var $this = $(this);
  
    if ($this.next().hasClass('filter__list--active')) {
      $this.next().removeClass('filter__list--active');
      $this.next().slideUp(150);
    } else {
      $this.parent().parent().find('.filter__group .filter__list').removeClass('filter__list--active');
      $this.parent().parent().find('.filter__group .filter__list').slideUp(150);
      $this.next().toggleClass('filter__list--active');
      $this.next().slideToggle(150);
    }

    if ($this.hasClass('filter__title--active')) {
      $this.removeClass('filter__title--active');
    } else {
      $this.parent().find('.filter__group .filter__title').removeClass('filter__title--active');
      $this.toggleClass('filter__title--active');
    }

  });


}
// Canvas Cart
var dataOffcanvas;
$(document).ready(function() { 
  $( function(){


    $( document ).on( "beforecreate.offcanvas", function( e ){
      dataOffcanvas = $( e.target ).data('offcanvas-component');
    } );

    $( document ).on( "create.offcanvas", function( e ){
      var dataOffcanvas = $( e.target ).data('offcanvas-component');

    } );

    $( document ).on( "clicked.offcanvas-trigger clicked.offcanvas", function( e ){
      var dataBtnText = $( e.target ).text();
    } );

    $( document ).on( "open.offcanvas", function( e ){
      var dataOffcanvasID = $( e.target ).attr('id');
    } );

    $( document ).on( "resizing.offcanvas", function( e ){
      var dataOffcanvasID = $( e.target ).attr('id');
    } );

    $( document ).on( "close.offcanvas", function( e ){
      var dataOffcanvasID = $( e.target ).attr('id');
    } );

    $( document ).on( "destroy.offcanvas", function( e ){
      var dataOffcanvasID = $( e.target ).attr('id');
    } );

    $( '#bottom' ).on( "create.offcanvas", function( e ){
      var api = $(this).data('offcanvas-component');

      $('.js-destroy').on('click', function () {
        api.destroy();
        //$( '#top' ).data('offcanvas-component').destroy();
      });
    } );

    $( '#left' ).offcanvas( {
      modifiers: "left,overlay",
      triggerButton: '.js-offcanvas-trigger-left'
    } );

    $('.js-enhance').on('click', function () {
      $( document ).trigger( "enhance" );
    });

    $( document ).trigger( "enhance" );
    
  });
});

// Filter Switch
function setCookie(cname,cvalue) {
  var d = new Date();
  d.setTime(d.getTime() + (365*24*60*60*1000));
  var expires = "expires=" + d.toGMTString();
  if((typeof cvalue)!="string")   var cvalue_string=JSON.stringify(cvalue);
  else var cvalue_string=cvalue;
  document.cookie = cname + "=" + cvalue_string + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  } 
}

var layouts={
  desktop:[4,3],
  tablet:[3,2],
  mobile:[2,1]
}

function getWindowLayout() {
  var _windowWidth=jQuery(window).width();
  if ( _windowWidth< 767) {
    return layouts.mobile;
  }
  else if (_windowWidth < 1024) {
    return layouts.tablet;
  }
  else {
    return layouts.desktop;
  }
}

function switchLayout(isFirst,isNext) {
  var perRow=1;
  if (isFirst===true) {
    var _perCookie= getCookie("perrow");
    if (_perCookie!=undefined) perRow=parseInt(_perCookie);
  }
  var currentPerRow=$('.filter-switch__grid').get(0).className.match(/show(\d)/);
  if (currentPerRow!=null) {
    perRow=parseInt(currentPerRow[1]); 
  }
  var _currentLayout=getWindowLayout();

  if ($.inArray(perRow, _currentLayout)==-1) {
    perRow=_currentLayout[0];
  } 

  if (isNext===true) {
    perRow=_currentLayout[($.inArray(perRow, _currentLayout) + 1) % _currentLayout.length];
    setCookie("perrow",perRow);     
  }

  if(currentPerRow!=null) {     
    $('.filter-switch__grid').removeClass("filter-switch__grid--show"+currentPerRow[1]);   
    //$('.collection .col').removeClass("show"+currentPerRow[1]);   
  }
  $('.filter-switch__grid').addClass("filter-switch__grid--show"+perRow);  

  $('.collection .col').each(function() {
    var cn=this.className.match('xs-3');
    if (cn!=null) $(this).removeClass(cn[0]);
    var cn=this.className.match('xs-4');
    if (cn!=null) $(this).removeClass(cn[0]);
    var cn=this.className.match('xs-6');
    if (cn!=null) $(this).removeClass(cn[0]);
    var cn=this.className.match('xs-12');
    if (cn!=null) $(this).removeClass(cn[0]);
    var _classname="xs-3";
    switch(perRow) {
      case 1:      
      _classname="xs-12";
      break;
      case 2:
      _classname="xs-6";
      break;
      case 3:
      _classname="xs-4";
      break;
    }
    $(this).addClass(_classname);
  });
}

function layoutSwitch (isFirst) {
  if ($('.filter-switch').length>0) {
    switchLayout(isFirst);

    $('.filter-switch').off('click');
    $('.filter-switch').on('click',function() {
      switchLayout(false,true);
    });
  }
}
$(document).ready(function() {
  $(window).on('load resize', function() {
    layoutSwitch(true);
  });
});

// Header Sticky
var previousScroll = 0;
var headerOrgOffset =0;
if ($('.header').length>0)  headerOrgOffset =$('.header').offset().top;

$(window).scroll(function () {
  if ($('.header').length>0) {
    var currentScroll = $(this).scrollTop();
    if (currentScroll > headerOrgOffset) {
      if (currentScroll > previousScroll) {
        $('html:not(".no-scroll") .header').removeClass('header--sticky');
        //$('html:not(".no-scroll") .boost-pfs-search-suggestion-mobile-top-panel').removeClass('boost-pfs-search-suggestion-mobile-top-panel--sticky');
      } else {
        $('html:not(".no-scroll") .header').addClass('header--sticky');
        //$('html:not(".no-scroll") .boost-pfs-search-suggestion-mobile-top-panel').addClass('boost-pfs-search-suggestion-mobile-top-panel--sticky');
      }
    } else {
      $('html:not(".no-scroll") .header').removeClass('header--sticky');
      //$('html:not(".no-scroll") .boost-pfs-search-suggestion-mobile-top-panel').removeClass('boost-pfs-search-suggestion-mobile-top-panel--sticky');
    }
    previousScroll = currentScroll;
  }
});

// Filter Sticky
if ($(".filters")[0]) {
  var previousScrollFilter = 0,
  headerOrgOffsetFilter = $('.filters').offset().top + (-62);

  $(window).scroll(function (e) {
    var currentScrollFilter = $(this).scrollTop();
    if (currentScrollFilter > headerOrgOffsetFilter) {
      if (currentScrollFilter > previousScrollFilter) {
        $('html:not(".no-scroll") .filters__container').removeClass('filters__container--sticky');
      } else {
        $('html:not(".no-scroll") .filters__container').addClass('filters__container--sticky');
      }
    } else {
      $('html:not(".no-scroll") .filters__container').removeClass('filters__container--sticky');
    }
    previousScrollFilter = currentScrollFilter;
  });
}

// Product Page - Sticky Button
$(document).on('scroll', function(){
  if ($(window).scrollTop() > 50){
    $('.product-add-mobile').addClass('product-add-mobile--sticky');
  } else {
    $('.product-add-mobile').removeClass('product-add-mobile--sticky');
  }
});

// // Header Search Toggle
// $(document).ready(function() {
//   $('.header-search__toggle').click(function () {
//     $('.header-search__form').toggleClass('header-search__form--visible');
//     $('.site-container').toggleClass('site-container--blackout');
//     $('.header-search__input').focus();
//   });
//   $(document).click(function (e) {
//     if (!$(e.target).is(".header *")) {
//       $('.site-container').removeClass('site-container--blackout');
//       $('.header-search__form').removeClass('header-search__form--visible');
//     }
//   });
// });       

// Slick Carousels
function heroCarouselDesktop() {
  // Hero Carousel (Tablet/Desktop)        
  $('.hero__carousel--desktop:not(.slick-initialized)').slick({
    dots: true,
    infinite: false,
    lazyLoad: 'ondemand',
    autoplay: true,
    useAutoplayToggleButton: false,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    pauseOnFocus: true,
    touchMove: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          arrows: false,
        }
      }
    ]
  });
}

function heroCarouselMobile() {
  // Hero Carousel (Mobile Only)
  $('.hero__carousel--mobile:not(.slick-initialized)').slick({
    dots: true,
    arrows: false,
    infinite: false,
    lazyLoad: 'ondemand',
    autoplay: true,
    useAutoplayToggleButton: false,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    pauseOnFocus: true,
    touchMove: true
  });
}

function heroTextCarousel() {
  // Hero Text Carousel
  $('.hero-text__carousel:not(.slick-initialized)').slick({
    dots: true,
    infinite: false,
    lazyLoad: 'ondemand',
    autoplay: true,
    useAutoplayToggleButton: false,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    pauseOnFocus: true,
    touchMove: true,
    //slide: '.hero-text__banner',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          arrows: false,
        }
      }
    ]
  });
}

function promosCarousel() {
  // USP Carousel //
  $(window).on('load resize orientationchange', function() {
    $('.promos__carousel').each(function(){
      var $carousel = $(this);
      /* Initializes a slick carousel only on mobile screens */
      // slick on mobile
      if (window.innerWidth > 1365) {
        if ($carousel.hasClass('slick-initialized')) {
          $carousel.slick('unslick');
        }
      }
      else{
        if (!$carousel.hasClass('slick-initialized')) {
          $carousel.slick({
            dots: false,
            arrows: false,
            infinite: true,
            autoplay: true,
            useAutoplayToggleButton: false,
            autoplaySpeed: 1200,
            speed: 800,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
            {
              breakpoint: 1023,
              settings: {
                slidesToShow: 3,
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
              }
            }
            ]
          });
        }
      }
    });
  });

}

function brandsCarousel() {
  // Brands Carousel
  $('.brands__carousel:not(.slick-initialized)').slick({
    dots: true,
    arrows: true,
    infinite: false,
    autoplay: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        }
      }
    ]
  });  
}

function featuredCollectionCarousel() {
  // Featured Collection Carousel
  $('.featured-collection__carousel:not(.slick-initialized)').slick({
    slidesToShow: 4,
    slidesToScroll: 4,
    dots: true,
    infinite: false,
    //slide: '.col',
    lazyLoad: 'ondemand',
    touchMove: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          arrows: false,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: false,
        }
      }
    ]
  });
}

function productFeaturedCarousel() {
  var slideWrapper = $(".product-images__featured-carousel"),
      iframes = slideWrapper.find('.product-images__embed-player'),
      lazyImages = slideWrapper.find('.product-images__featured-item'),
      lazyCounter = 0;

  // POST commands to YouTube or Vimeo API
  function postMessageToPlayer(player, command){
    if (player == null || command == null) return;
    player.contentWindow.postMessage(JSON.stringify(command), "*");
  }

  // When the slide is changing
  function playPauseVideo(slick, control){
    var currentSlide, slideType, startTime, player, video;

    currentSlide = slick.find(".slick-current");
    slideType = currentSlide.attr("class").split(" ")[1];
    player = currentSlide.find("iframe").get(0);
    startTime = currentSlide.data("video-start");

    if (slideType === "vimeo") {
      switch (control) {
        case "play":
          if ((startTime != null && startTime > 0 ) && !currentSlide.hasClass('started')) {
            currentSlide.addClass('started');
            postMessageToPlayer(player, {
              "method": "setCurrentTime",
              "value" : startTime
            });
          }
          postMessageToPlayer(player, {
            "method": "play",
            "value" : 1
          });
          break;
        case "pause":
          postMessageToPlayer(player, {
            "method": "pause",
            "value": 1
          });
          break;
      }
    } else if (slideType === "youtube") {
      switch (control) {
        case "play":
          postMessageToPlayer(player, {
            "event": "command",
            "func": "mute"
          });
          postMessageToPlayer(player, {
            "event": "command",
            "func": "playVideo"
          });
          break;
        case "pause":
          postMessageToPlayer(player, {
            "event": "command",
            "func": "pauseVideo"
          });
          break;
      }
    } else if (slideType === "video") {
      video = currentSlide.children("video").get(0);
      if (video != null) {
        if (control === "play"){
          video.play();
        } else {
          video.pause();
        }
      }
    }
  }

  // Resize player
  function resizePlayer(iframes, ratio) {
    if (!iframes[0]) return;
    var win = $(".product-images__featured-carousel"),
        width = win.width(),
        playerWidth,
        height = win.height(),
        playerHeight,
        ratio = ratio || 16/9;

    iframes.each(function(){
      var current = $(this);
      if (width / ratio < height) {
        playerWidth = Math.ceil(height * ratio);
        current.width(playerWidth).height(height).css({
          left: (width - playerWidth) / 2,
           top: 0
          });
      } else {
        playerHeight = Math.ceil(width / ratio);
        current.width(width).height(playerHeight).css({
          left: 0,
          top: (height - playerHeight) / 2
        });
      }
    });
  }

  // DOM Ready
  $(function() {
    // Initialize
    slideWrapper.on("init", function(slick){
      slick = $(slick.currentTarget);
      setTimeout(function(){
        playPauseVideo(slick,"play");
      }, 1000);
      resizePlayer(iframes, 16/9);
    });
    slideWrapper.on("beforeChange", function(event, slick) {
      slick = $(slick.$slider);
      playPauseVideo(slick,"pause");
    });
    slideWrapper.on("afterChange", function(event, slick) {
      slick = $(slick.$slider);
      playPauseVideo(slick,"play");
    });
    slideWrapper.on("lazyLoaded", function(event, slick, image, imageSource) {
      lazyCounter++;
      if (lazyCounter === lazyImages.length){
        lazyImages.addClass('show');
        // slideWrapper.slick("slickPlay");
      }
    });

    //start the slider
    slideWrapper.slick({
      // fade:true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplaySpeed:4000,
      lazyLoad:"progressive",
      speed:600,
      dots: false,
      arrows: true,
      infinite: false,
      //cssEase:"cubic-bezier(0.87, 0.03, 0.41, 0.9)"
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
          }
        }
      ]
    });
  });

  // Resize event
  $(window).on("resize.slickVideoPlayer", function(){  
    resizePlayer(iframes, 16/9);
  });
}

function productThumbsCarousel() {  
  // Change the main image whenever a thumbnail button is activated
  $('.product-images__thumbs-carousel').on('init', function(e, slider) {
    $(slider.$slides.find('.product-images__thumb-link')).each(function(index) {
      $(this).on('click', function() {
        // Move aria-current="true" to this button
        $(slider.$slides.find('.product-images__thumb-link').removeAttr('aria-current'));
        $(this).attr('aria-current', true);

        // Change the main image to match this thumbnail button
        var index = $(this).closest('.slick-slide').data('slick-index');
        $('.product-images__thumbs-carousel').slick('slickGoTo', index);
      });
    });
  });
  $('.product-images__thumbs-carousel:not(.slick-initialized)').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.product-images__featured-carousel',
    dots: false,
    infinite: false,
    arrows: true,
    centerMode: false,
    vertical: true
  });
}

// Swipebox
$(document).ready(function() { 
  if(jQuery().swipebox) {
    $( '.swipebox' ).swipebox();
  }
});

// Collection Description Toggle
$(document).ready(function() { 
  $('.collection__toggle').off('click').on('click', function () {
    $('.collection__description').toggleClass('collection__description--visible');
    $('.collection__show-hide').toggle();
    return false;
  });
});

// Footer Accordions
$(document).ready(function() { 
  $('.footer-content__accordion-header').off('click').on('click', function () {
    $(this).toggleClass('footer-content__accordion-header--shown');
    $(this).next('.footer-content__accordion-content').slideToggle(200);
    return false;
  });
});

// Help Accordions
$(document).ready(function() { 
  $('.help__sidebar-header').off('click').on('click', function () {
    $(this).toggleClass('help__sidebar-header--shown');
    $(this).next('.help__sidebar-links').slideToggle(200);
    return false;
  });
});

// Cookie Notice 
// function _showCookieBar() {
//   if (Shopify.designMode!==true)  {
//     $('.cookie-notice').cookieBar({
//       'closeButton': '.cookie-notice__button',
//     });
//   }
// }

// Currency Converter
$(document).ready(function() { 
  $('.shopify-currency-form select').on('change', function() {
    $(this)
      .parents('form')
      .submit();
  });
});

// Nav Mega Hover
$(".nav__mega .nav__sub-menu").css('display', 'flex').hide();
$(".nav__single .nav__sub-menu").css('display', 'block').hide();
$(".nav__dropdown").on("mouseenter", function (e) {
  if (window.innerWidth > 1279) {
    $('.nav-overlay').stop(!0, !0).delay(250).fadeIn();
    $(this).children(".nav__sub-menu").stop(!0, !0).delay(250).fadeIn();
    $(this).children(".nav__link").children("span").stop(!0, !0).delay(250).fadeIn();
  }
});
$(".nav__dropdown").on("mouseleave", function (e) {
  if (window.innerWidth > 1279) {
    $('.nav-overlay').stop(!0, !0).delay(250).fadeOut();
    $(this).children(".nav__sub-menu").stop(!0, !0).delay(250).fadeOut();
    $(this).children(".nav__link").children("span").stop(!0, !0).delay(250).fadeOut();
  }
});

// Finance Popup - Klarna
$('.product-finance__link--klarna-30').on('click', function () {
  $('.product-finance-popup--klarna-30').addClass('product-finance-popup--active');
  $('html').addClass('noscroll-finance-popup');
});
$('.product-finance__link--klarna').on('click', function () {
  $('.product-finance-popup--klarna').addClass('product-finance-popup--active');
  $('html').addClass('noscroll-finance-popup');
});

// Finance Popup - Clearpay
$('.product-finance__link--clearpay').on('click', function () {
  $('.product-finance-popup--clearpay').addClass('product-finance-popup--active');
  $('html').addClass('noscroll-finance-popup');
});

// Finance Popup - Laybuy
$('.product-finance__link--laybuy').on('click', function () {
  $('.product-finance-popup--laybuy').addClass('product-finance-popup--active');
  $('html').addClass('noscroll-finance-popup');
});

// Finance Popup - Ideal
$('.product-finance__link--ideal').on('click', function () {
  $('.product-finance-popup--ideal').addClass('product-finance-popup--active');
  $('html').addClass('noscroll-finance-popup');
});

// Finance Popup - Close
$('.product-finance-popup__close').on('click', function () {
  $('.product-finance-popup').removeClass('product-finance-popup--active');
  $('html').removeClass('noscroll-finance-popup');
});

$(document).mouseup(function(e) {
  var container = $(".product-finance-popup *");
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    $('.product-finance-popup--active').removeClass('product-finance-popup--active');
    $('html').removeClass('noscroll-finance-popup');
  }
});

// Account Tabs
$('.account .tab').on('click', function () {
  var tab_id = $(this).attr('data-tab');
  $('.account__tab').removeClass('account__tab--active');
  $('.account__content').hide();
  $(this).addClass('account__tab--active');
  $("#"+tab_id).show();
});

// Mobile Nav
$(document).ready(function() { 

  // Clone
  $('.nav__sub-menu').each(function(){
    $(this).clone().addClass('nav__sub-menu--cloned').insertAfter(".header-nav").wrapInner("<div class='nav__sub-menu__wrap'></div>");
  });

  // Open & Close Nav (Mobile) - Click Function
  $('.header-mobile').off('click').on('click', function () {
    $(this).toggleClass('header-mobile--active');
    $('.header-nav').toggle();
    $('.header-nav').toggleClass('header-nav--active');
    $('html').toggleClass('no-scroll-mobile-nav');
    $('.mobile-nav-overlay').toggle();
    $('.nav__sub-menu--cloned').removeClass('nav__sub-menu--active');
    $('.nav').removeClass('nav--hidden');
  });

  // Close Nav (Mobile) - Click Function
  $('.mobile-nav-overlay').off('click').on('click', function () {
    $('.header-mobile').removeClass('header-mobile--active');
    $('.header-nav').hide();
    $('.header-nav').removeClass('header-nav--active');
    $('html').removeClass('no-scroll-mobile-nav');
    $('.mobile-nav-overlay').hide();
    $('.nav').removeClass('nav--hidden');
    $('.nav__sub-menu--cloned').removeClass('nav__sub-menu--active');
  });

  // Open Sub Menu - Click Function
  $('.nav__dropdown .nav__link').off('click').on('click', function (event) {
    if ($(window).width() < 1280) {
      event.preventDefault();
    }
    var id = $(this).attr('id');
    $('.nav__sub-menu').each(function(){
      var dataid = $(this).attr('data-id');
      console.log(dataid);
      if(id == dataid) {
        $(this).addClass('nav__sub-menu--active');
      }
    });
    $('.nav').addClass('nav--hidden');
  });

  // Back Button - Click Function
  $('.nav__sub-menu__back').off('click').on('click', function () {
    $('.nav__sub-menu').removeClass('nav__sub-menu--active');
    $('.nav').removeClass('nav--hidden');
  });

});

// Accordion
function productAccordion() { 
  var $tabs = $('.product-accordion');
  if ($tabs.length>0) {
  $tabs.responsiveTabs({
    rotate: false,
    startCollapsed: true,
    collapsible: 'accordion',
    animation: 'slide',
    duration: 300,
    setHash: false,
    disabled: [],
    classes: {
      stateDefault: '',
      stateActive: 'active',
      stateDisabled: '',
      stateExcluded: '',
      container: '',
      ul: 'product-accordion__nav',
      tab: '',
      anchor: 'product-accordion__anchor',
      panel: 'product-accordion__panel',
      accordionTitle: 'product-accordion__title'
    }
  });
  }
}

// Accordion
function faqsAccordion() { 
  var $faqstabs = $('.faqs-accordion');
  if ($faqstabs.length>0) {
  $faqstabs.responsiveTabs({
    rotate: false,
    startCollapsed: true,
    collapsible: 'accordion',
    animation: 'slide',
    duration: 300,
    setHash: false,
    disabled: [],
    classes: {
      stateDefault: '',
      stateActive: 'active',
      stateDisabled: '',
      stateExcluded: '',
      container: '',
      ul: 'faqs-accordion__nav',
      tab: '',
      anchor: 'faqs-accordion__anchor h4',
      panel: 'faqs-accordion__panel',
      accordionTitle: 'faqs-accordion__title'
    }
  });
  }
}


// RESPONSIVE TABS
function _faqsAccordion() {  
  if (window.tabs1) {
    window.tabs1.forEach(x=> {
      $(x).responsiveTabs({
        rotate: false,
        startCollapsed: true,
        collapsible: 'accordion',
        animation: 'slide',
        duration: 300,
        setHash: false,
        disabled: [],
        classes: {
          stateDefault: '',
          stateActive: 'active',
          stateDisabled: '',
          stateExcluded: '',
          container: '',
          ul: 'faqs-accordion__nav',
          tab: '',
          anchor: 'faqs-accordion__anchor',
          panel: 'faqs-accordion__panel',
          accordionTitle: 'faqs-accordion__title'
        }
      });
    });
  }
}

// Swatches
function initSwatches() {
  if (window.swatches!=undefined && document.location) {
    $('.swatches__col').off('mouseenter mouseleave');
    $('.swatches__col').off('click');

    if ($(window).width() > 599) {
    $('.swatches__col').hover(      
      function(){
        if ($(this).closest('[data-group-col]').length>0) {
        let _id=$(this).data('product-id');
        let _h=window.swatches.filter(function (e) { return (e.id  == _id )});
        if (_h.length>0) {                                                      
          showSwatchData(this,_h[0]);
        }
        else  {
          //swatch data not exist - need get firstly
          let el=this;
          var _handle;
          if (productsForFilter.length==0) {
            _handle=$(this).attr('href').replace('/products/','');
          }
          else {
            _handle=productsForFilter.filter(item => item.id === window.btoa('gid://shopify/Product/'+_id))[0].handle;
          }
          if (_handle!=undefined) {
            getSwatchData(_handle,function(h) {
              showSwatchData(el,this);
            });
          }
        }
        }
      },function(){
        if ($(this).closest('[data-group-col]').length>0) {
        let _id=$(this).parent().find("[class*='--current']").closest('a').data('product-id');
        let _h=window.swatches.filter(function (e) { return (e.id  ==  _id )});
        if (_h.length>0) {                                                      
          showSwatchData(this,_h[0]);
        }
      }
    }
    );
   }
   else {
     $('.swatches__col').on('click',function(e) {
       if ($(this).closest('[data-group-col]').length>0) {
        if ( $('div',this).hasClass('swatches__swatch--current')) return true;
        e.preventDefault();
        $(this).closest('.swatches').find('.swatches__swatch--current').removeClass('swatches__swatch--current');
        $('div',this).addClass('swatches__swatch--current');
        const _id=$(this).data('product-id');
        const _h=window.swatches.filter(function (e) { return (e.id  == _id )});
        if (_h.length>0) {                                                      
          showSwatchData(this,_h[0]);
        }
        else  {
          //swatch data not exist - need get firstly
          const el=this;
          var _handle;
          if (productsForFilter.length==0) {
            _handle=$(this).attr('href').replace('/products/','');
          }
          else {
            _handle=productsForFilter.filter(item => item.id === window.btoa('gid://shopify/Product/'+_id))[0].handle;
          }
          if (_handle!=undefined) {
          	getSwatchData(_handle,function(h) {
            	showSwatchData(el,this);
          	});
          }
        }
       return false;
       }
     });
 
   }

  }
}

function getSwatchData(_handle,callback) {     
  $.ajax({
      method    : 'GET',
      url       : document.location.origin+"/products/"+_handle+"/?view=swatch",        
      success: function (data) {
        var _d=data.replace(/\n/g,'').replace(/,}/g,'}');   
        window.swatches=window.swatches || [];
        const h=JSON.parse(_d);
        window.swatches.push(h);
    callback.apply(h);
   }
});
}
function showSwatchData(el,h) {
  var item=$(el).closest('.product-card');
  item.find('.product-card__image').attr("src", h.image);
    item.find('.product-card__image').attr("srcset", "");
  item.find('.product-card__title').text(h.title);
  item.find('.product-card__sku span').text(h.sku);
  item.find('.product-card__price-current').text(h.price);
  item.find('.product-card__price').removeClass('product-card__price--on-sale');
  item.find('.product-card__price').addClass(h.onsale);
  item.find('.product-card__price-compare').text(h.pricecompare);
  item.find('.product-card__price-saving').html(h.saving);
  item.find('.product-card__overlays').replaceWith(h.overlays); 
}

// DAWN SLIDER
function dawnSlider() {
  function pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach((video) => {
      video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    document.querySelectorAll('.js-vimeo').forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    document.querySelectorAll('video').forEach((video) => video.pause());
    document.querySelectorAll('product-model').forEach((model) => {
      if (model.modelViewerUI) model.modelViewerUI.pause();
    });
  }

  class SliderComponent extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('[id^="Slider-"]');
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.enableSliderLooping = false;
      this.buttonsElement = this.querySelector('.slider-buttons');
      this.currentPageElement = this.querySelector('.slider-counter--current');
      this.pageTotalElement = this.querySelector('.slider-counter--total');
      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');

      if (!this.slider || !this.nextButton) return;

      this.initPages();
      const resizeObserver = new ResizeObserver(entries => this.initPages());
      resizeObserver.observe(this.slider);

      this.slider.addEventListener('scroll', this.update.bind(this));
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }
        
    reset() {
      this.slider = this.querySelector('[id^="Slider-"]');
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.enableSliderLooping = false;
      this.buttonsElement = this.querySelector('.slider-buttons');
      this.currentPageElement = this.querySelector('.slider-counter--current');
      this.pageTotalElement = this.querySelector('.slider-counter--total');
      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');

      if (!this.slider || !this.nextButton) return;

      this.initPages();
      const resizeObserver = new ResizeObserver(entries => this.initPages());
      resizeObserver.observe(this.slider);

      this.slider.addEventListener('scroll', this.update.bind(this));
      //this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      //this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }

    initPages() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemOffset);
      this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
      this.update();
    }

    resetPages() {
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.initPages();
    }

    update() {
      const previousPage = this.currentPage;
      this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

      if (this.currentPageElement && this.pageTotalElement) {
        this.currentPageElement.textContent = this.currentPage;
        this.pageTotalElement.textContent = this.totalPages;
        this.buttonsElement.classList = "slider-buttons slider-buttons--active slider-buttons" + this.totalPages;
      }

      if (this.currentPage != previousPage) {
        this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1]
        }}));
      }

      if (this.enableSliderLooping) return;

      if (this.isSlideVisible(this.sliderItemsToShow[0])) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }

      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }

    isSlideVisible(element, offset = 0) {
      const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
      return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
    }

    onButtonClick(event) {
      event.preventDefault();
      const step = event.currentTarget.dataset.step || 1;
      this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
      this.slider.scrollTo({
        left: this.slideScrollPosition
      });
    }
  }
  customElements.define('slider-component', SliderComponent);

  class SlideshowComponent extends SliderComponent {
    constructor() {

      super();
      this.sliderControlWrapper = this.querySelector('.slider-buttons');
      this.enableSliderLooping = true;

      if (!this.sliderControlWrapper) return;

      this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
      if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

      this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
      this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
      this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
      this.setSlideVisibility();

      if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();

    }

    reset() {
      super.reset();
      this.sliderControlWrapper = this.querySelector('.slider-buttons');
      this.enableSliderLooping = true;

      if (!this.sliderControlWrapper) return;

      this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
      if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

      this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
      this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
      this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
      this.setSlideVisibility();

      if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
    }
    setAutoPlay() {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.autoplaySpeed = this.slider.dataset.speed * 1000;

      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.addEventListener('mouseover', this.focusInHandling.bind(this));
      this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
      this.addEventListener('focusin', this.focusInHandling.bind(this));
      this.addEventListener('focusout', this.focusOutHandling.bind(this));

      this.play();
      this.autoplayButtonIsSetToPlay = true;
    }

    onButtonClick(event) {
      super.onButtonClick(event);
      const isFirstSlide = this.currentPage === 1;
      const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

      if (!isFirstSlide && !isLastSlide) return;

      if (isFirstSlide && event.currentTarget.name === 'previous') {
        this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
      } else if (isLastSlide && event.currentTarget.name === 'next') {
        this.slideScrollPosition = 0;
      }
      this.slider.scrollTo({
        left: this.slideScrollPosition
      });
    }

    update() {
      super.update();
      this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
      this.prevButton.removeAttribute('disabled');

      if (!this.sliderControlButtons.length) return;

      this.sliderControlButtons.forEach(link => {
        link.classList.remove('slider-counter__link--active');
        link.removeAttribute('aria-current');
      });
      this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
      this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
    }

    autoPlayToggle() {
      this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
      this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
      this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
    }

    focusOutHandling(event) {
      const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    }

    focusInHandling(event) {
      const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    }

    play() {
      this.slider.setAttribute('aria-live', 'off');
      clearInterval(this.autoplay);
      this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
    }

    pause() {
      this.slider.setAttribute('aria-live', 'polite');
      clearInterval(this.autoplay);
    }

    togglePlayButtonState(pauseAutoplay) {
      if (pauseAutoplay) {
        this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
        this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
      } else {
        this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
        this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
      }
    }

    autoRotateSlides() {
      const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
      this.slider.scrollTo({
        left: slideScrollPosition
      });
    }

    setSlideVisibility() {
      this.sliderItemsToShow.forEach((item, index) => {
        const button = item.querySelector('a');
        if (index === this.currentPage - 1) {
          if (button) button.removeAttribute('tabindex');
          item.setAttribute('aria-hidden', 'false');
          item.removeAttribute('tabindex');
        } else {
          if (button) button.setAttribute('tabindex', '-1');
          item.setAttribute('aria-hidden', 'true');
          item.setAttribute('tabindex', '-1');
        }
      });
    }

    linkToSlide(event) {
      event.preventDefault();
      const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
      this.slider.scrollTo({
        left: slideScrollPosition
      });
    }
  }
  customElements.define('slideshow-component', SlideshowComponent);
}

// Run Functions
function _checkafterLoadEvents() {
   window.afterLoadWithEvents.forEach(x=> {
      
      if (x.evt && !$(x.el).is(document)) {
        if ( x.evt==arguments[0].type && $(x.el).is(arguments[0].target)) {
	        $(x.el).off(x.evt+'.'+x.f)
            if (typeof(x.f)=='function') {
              setTimeout(x.f,0);
            }
          	else {
    	    	window[x.f].apply();
            }
        	window.afterLoadWithEvents.splice(window.afterLoadWithEvents.indexOf(x),1);  
        }
      }
      else {
       if (typeof(x.f)=='function') {
         	setTimeout(x.f,0);
       }
       else {
    	   window[x.f].apply();
       }
       window.afterLoadWithEvents.splice(window.afterLoadWithEvents.indexOf(x),1);  
      }
       
   });
   if (window.afterLoadWithEvents.length==0) {
     $(window).off('scroll.afterLoad');
   }
}
  function loadswatches(ismissed) {
    if (ismissed!==true) {
     //product detail group swatch    
  $('[data-group]').each(function() {
    let el=$(this);
    $.ajax({
        method    : 'GET',
        url       : document.location.origin+"/collections/all/product-group-code-"+$(this).data('group')+"/?view=product-swatch",        
        success: function (data) {
          el.empty().append(data);
          $('[data-group]').find('[href="'+document.location.pathname+'"] .swatches__swatch').addClass('swatches__swatch--current');
        }
   });
  });
    }
  let sEl=$('[data-group-col]');    
  if (ismissed!==true) {
    sEl=$('[data-group-col]:not(:has(.swatches__col))');
  }      
  if (sEl.length>0) {
     let tags=[];
    sEl.each(function() {
      const t='Size Group Code|'+$(this).data('group-col');
      if (!tags.includes(t)) tags.push(t);    
    });
    renderSwatchAndOverlay(tags,function() {
      sEl.each(function() {
        let overlayHtml='';
        let htmlItems=[];
        let _tag=$(this).data('group-col');
        let _productsForTag=_productsForTags.filter(p=>p.tag==_tag);        
        let _id=$(this).data('group-col-id');
        if (_productsForTag.length==0) {                  
             _productsForTags.push({
                  tag:_tag,
                  products:_productsData.filter(p=>p.GroupCode==_tag)
             });
             _productsForTag=_productsForTags.filter(p=>p.tag==_tag);
        }
        if (_productsForTag.length>0){   
        	_productsForTag[0].products.forEach(p=>{                    
            	let current='';
            	if (_id==p.id){
                	current="swatches__swatch--current"; 
                	overlayHtml=p.overlay;
            	}
            	htmlItems.push(_swatchSettings.item.replace('{{id}}',p.id).replace('{{url}}',p.handle).replace('{{color}}',p.swatchColor).replaceAll('{{name}}',p.swatchName).replace('{{current}}',current));
        	});
       		$(this).empty().append(htmlItems.join(''));
          	//$(this).closest('.product-card').find('.product-card__image-link .product-card__overlays').remove();
            //$(this).closest('.product-card').find('.product-card__image-link').append(overlayHtml);
         }
      });
      window.swatches=[];
      initSwatches();
    });
  }
}
function register() {
  jQuery('html').removeClass('no-js').addClass('js');
  if (window.ReadyScript) {
    window.ReadyScript.forEach(x=> {
      loadScript(x.s,x.c);
    });
  }
  if (window.afterLoad) {
    window.afterLoad.forEach(x=> {
      if (x.p!=undefined) {
        window[x.f].apply(x.p);      
      }
      else {
        window[x.f].apply();      
      }
    });    
  }
  
  if (window.afterLoadWithEvents) {
    $(window).on('scroll.afterLoad',_checkafterLoadEvents);
    window.afterLoadWithEvents.forEach(x=> {
      if (x.evt) {
        $(x.el).on(x.evt+'.'+x.f,_checkafterLoadEvents)
      }
    });
  }
    
  heroCarouselDesktop();
  heroCarouselMobile();
  heroTextCarousel();
  promosCarousel();
  brandsCarousel();
  featuredCollectionCarousel();
  productFeaturedCarousel();
  productThumbsCarousel();
  productAccordion();
  faqsAccordion();
  dawnSlider();
}
  
// window.afterLoadWithEvents = window.afterLoadWithEvents || [];
//   window.afterLoadWithEvents.push(
//   {
//       f:"_register",
//       evt: 'mousemove',
//       el: document
//   });
// function _register() {
//   checkUserLocation();
// };
$(document).ready(function(){
  register(); 
  if ($('[data-cart-qty]').length>0) {
    $('[data-cart-qty]').on('focusout',function() {
      if (parseInt($(this).data('cart-qty'))!=parseInt($(this).val())) {
        $(this).closest('form').get(0).submit();
      }
    });
  }
});

// load scripts after page load
function loadScript(sc,callback) {
  if ($.isArray(sc)) {    
      let lc = document.createElement('script'); lc.type = 'text/javascript'; 
  	  lc.src = sc[0];
      sc.splice(0,1);   
      if (sc.length>0) {
        $(lc).on('load',function() {loadScript(sc,callback)});           ;
      }
      else if (callback!=undefined) {
    	$(lc).on('load',function() {window[callback].apply()});   
  	  }
      document.getElementsByTagName('body')[0].appendChild(lc);
  }
  else {
    let lc = document.createElement('script'); lc.type = 'text/javascript'; 
  	lc.src = sc;
  	if (callback!=undefined) {
    	$(lc).on('load',function() {window[callback].apply()});   
  	}
	document.getElementsByTagName('body')[0].appendChild(lc);
  }
}


// For Theme Editor
document.addEventListener("shopify:section:load", function(event) {
  register();
});
  
  
 var _productsData=[];
  var _productsForTags=[];
  var _swatchSettings={
    template:'<div class="swatches product-card__swatches">{{items}}</div>',
    item:`<a class="swatches__col" data-product-id="{{id}}" href="/products/{{url}}" title="{{name}}">
	<div class="swatches__swatch {{current}}">
	  <span style="background-color: {{color}}"></span>
	</div>
	<div class="swatches__tag">{{name}}</div>
	</a>`,   
    overlay:'<div class="product-card__overlays"><div class="product-card__overlay product-card__overlay--{{overlay}}">{{message}}</div></div>'
  };
  function renderSwatchAndOverlay(tags,callback) {

    if (tags.length>0) {      
		var tagsVar="tag:'"+tags.join("' OR '")+"'";
  		FetchDataWithVariables(`query($tagsVar: String){
      			products( first: 250,query:$tagsVar) {
            	edges{
          			node {
			            id
			            handle
						title
						tags
						images(first:2) {    
							edges {       
								node {
									originalSrc     
									id
								}
							}
						}
						metafields (first: 20){
              				edges{
                				node{
          							value
          							key
              					}
            				}
						}
						variants(first: 100) {
      						edges {
        						node {       
									price
									compareAtPrice
									availableForSale
									id		  							
        						}
      						}
    					}
        			}
      			}  
    			}  			
		}`,{tagsVar},function(data) {
     		//console.log(data);
          
            let Products = data.data.products.edges;
  			for(let p of Products) {
              if (_productsData.filter(c=>c.id==p.node.id).length==0) {
    			let _product={
          			id:window.atob(p.node.id).replace('gid://shopify/Product/',''),
          			handle:p.node.handle,
                    title:p.node.title
        		};
              	_product.overlays=[]; 

    			for(let mf of p.node.metafields.edges) {                   
      				if (mf.node.key.indexOf('_overlay')!=-1) 
                      _product.overlays.push({key:mf.node.key,value:mf.node.value});
                    if (mf.node.key=='overlay') _product.overlays.push({key:mf.node.key,value:mf.node.value});
    			}
                p.node.tags.forEach(t=>{
                  if (t.startsWith("Size Group Code|")) _product.GroupCode=t.replace('Size Group Code|','');
                  if (t.startsWith("Size Name|")) _product.swatchName=t.replace('Size Name|','').toUpperCase();
                  if (t.startsWith("Size Colour|")) _product.swatchColor=t.replace('Size Colour|','');                 
                });
				
                
                
                _product.images_info=[];
                for(let v of p.node.images.edges) {   
                  _product.images_info.push({
                    id:v.node.id,
                    src:v.node.originalSrc,
                    width:1000,
                    height:1500
                  });      					
    			 }
 				 _product.variants=[];    
                let allowSale=false;
    			for(let v of p.node.variants.edges) {   
                  if (v.node.availableForSale===true) allowSale=true;
                  _product.variants.push({
                    id:v.node.id,
                    price:v.node.price,
                    available:v.node.availableForSale,
                    compare_at_price:v.node.compareAtPrice
                  });      					
    			}
                let minPriceVariant=_product.variants.sort((a, b) => a.price - b.price)[0];
    			_product.compare_at_price_min=parseFloat(minPriceVariant.compare_at_price);
                _product.price_min=parseFloat(minPriceVariant.price);
                 let _overlayHtml=_swatchSettings.overlay;
                 let overlayItems=[];
                 _product.overlays.forEach(o=> {
                        switch (o.key) {
                          case 'top_left_overlay':  
                            _overlayHtml=_overlayHtml.replace('{{overlay}}','top-left');
                            break;
                          case 'top_right_overlay':
                            _overlayHtml=_overlayHtml.replace('{{overlay}}','top-right');
                            break;
                          case 'bottom_overlay':
                            _overlayHtml=_overlayHtml.replace('{{overlay}}','bottom');
                            break;
                          default:
                            _overlayHtml=_overlayHtml.replace('{{overlay}}','');
                            break;
                        }
                        overlayItems.push(_overlayHtml.replace('{{message}}',o.value));
                 });
                _product.overlay=overlayItems.join('');
                if (allowSale) {
    				_productsData.push(_product);
                }
              }
  			}
          	//console.log(_productsData);
          	
          	
          	callback.apply();
		});
    }
  } 

document.addEventListener('lazybeforeunveil', function (e) {
    var bg = e.target.getAttribute('data-bg');
    if (bg) {
        e.target.style.backgroundImage = "url('" + bg + "')";
    }
});

// Product Page LightGallery Popup
if($("#lightgallery").length != 0) {
  lightGallery(document.getElementById('lightgallery'), {
    selector: '.product-images__featured-item',
    plugins: [lgZoom, lgThumbnail],
    speed: 500,
    thumbnail: false,
    getCaptionFromTitleOrAlt: false,
    licenseKey: 'C1DB9144-799D4957-B3C1226F-C451F4A3',
    mobileSettings: { 
      controls: true, 
      showCloseIcon: true,
      download: false, 
    }
  });
}

// Gallery Page LightGallery Popup
if($("#lightgallerypage").length != 0) {
  lightGallery(document.getElementById('lightgallerypage'), {
    selector: '.gallery__image-link',
    plugins: [lgZoom, lgThumbnail],
    speed: 500,
    thumbnail: false,
    getCaptionFromTitleOrAlt: true,
    licenseKey: 'C1DB9144-799D4957-B3C1226F-C451F4A3',
    mobileSettings: { 
      controls: true, 
      showCloseIcon: true,
      download: false, 
    }
  });
}

// Smooth Scroll
$(".designers__nav__link").click(function(e) {
  e.preventDefault();
  var targetElement = $(this).attr("href");
  var targetPosition = $(targetElement).offset().top;
  $("html, body").animate({ scrollTop: targetPosition - 0 }, "slow");
});


// Product Feature
$('.product-main__panel').on("DOMSubtreeModified",function(){

  if ($('.mw-apo-add-to-cart-cloned').length>0 && $('.mw-apo-add-to-cart-cloned').data('init')==undefined) {    
     $(".mw-apo-add-to-cart-cloned").data('init',true);    
    document.querySelectorAll(".mw-apo-add-to-cart-cloned")[0].addEventListener("click", function() {
       $(".loader").show();
    }, true);     
  }
  // //Smooth Scroll
  // $(document).ready(function(){
  //   $(".mw-tooltip a").click(function(e) {
  //     e.preventDefault();
  //     var targetElement = $(this).attr("href");
  //     var targetPosition = $(targetElement).offset().top;
  //     $("html, body").animate({ scrollTop: targetPosition - 0 }, "slow");
  //   });
  // });
  if ($(".mw-apo-container").length>0 && $(".mw-apo-container").data('init')==undefined) {    
    $(".mw-apo-container").data('init',true);
    $(".mw-option select").change(function(){
      $( ".mw-option__value-text" ).each(function() {
        let newtext = $(this).text().replace(/ *\([^)]*\) */g, "");
        $(this).text(newtext);
      });
      $(".mw-option__value-text").text().replace("(", "");
      if($(this).val() == "") {
        //console.log('yes');
        $(".product-panel").removeClass('product-panel--active');
      } else {
        $(".product-panel").addClass('product-panel--active');
        //console.log('no');
      }       
    });
  }
});

// Shed Types Tabs
$('.js-tab').off('click').on('click', function () {
  var t = $(this).data( "tab" );

  if($(this).hasClass('inactive')){ //this is the start of our condition 
    $(this).parent().children('.js-tab').addClass('inactive');
    $('.js-tab').each(function() {
      if ( $(this).data('tab') == t ) {      
        $(this).removeClass('inactive');
      }
    });

    $('.types__content').hide();
    $(this).parents('.doors__row').children('.doors__col--image').hide();
    $('#'+ t).show();
  }
});

// Video 
var vids = $("video"); 
$.each(vids, function(){
  this.controls = false; 
}); 
$("video").click(function() {
  if (this.paused) {
    this.play();
  } else {
    this.pause();
  }
});
$("video").bind('stop pause', function(e) {
  console.log("stopped");
  $(this).parent().removeClass('responsive-video--stopped');
});

$("video").bind('play', function(e) {
  console.log("playing");
  $(this).parent().addClass('responsive-video--stopped');
});

//Smooth Scroll
$(document).ready(function(){
  $(".product-group__tooltip-content a").click(function(e) {
    e.preventDefault();
    var targetElement = $(this).attr("href");
    var targetPosition = $(targetElement).offset().top;
    $("html, body").animate({ scrollTop: targetPosition - 0 }, "slow");
  });
});

// List Collections Description Show/Hide Toggle
$(document).ready(function() { 
  $('.list-collections__toggle').off('click').on('click', function () {
    $('.list-collections__description--show-hide').toggleClass('list-collections__description--show-hide-visible');
    $('.list-collections__show-hide').toggle();
    return false;
  });
});

// Collection Toggle
$(document).ready(function() { 
  $('.collection-intro__toggle').off('click').on('click', function () {
    $('.collection-intro__toggle').toggle();
    $('.collection-intro__hidden').slideToggle(200);
    return false;
  });
});

// Phone Popup
if($('.phone-popup').length>0) {
  // Open
  $('.phone-popup-button').on('click', function () {
    $('.phone-popup').addClass('phone-popup--active');
    $('html').addClass('noscroll-phone-popup');
  });

  // Close
  $('.phone-popup__close').on('click', function () {
    $('.phone-popup').removeClass('phone-popup--active');
    $('html').removeClass('noscroll-phone-popup');
  });
}